module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/BonusGirl-9b9b23d4a83f79d46dfe1e70bd8492b9.png";